export * from "./jira-software-features-page.template";
export { JiraSoftwareFeaturesPageTemplate as default } from "./jira-software-features-page.template";
export { JiraSoftwareFeaturesPageTemplate as JiraSoftwareFeaturesPageTemplateV2 } from "./jira-software-features-page-v2.template";
